<!--/* eslint-disable */-->
<template>

  <div>

    <vs-row vs-type="flex">
      <vs-col vs-w="12">
        <h4>{{title}}</h4>
      </vs-col>
    </vs-row>

    <div class="grid grid-cols-2 gap-1">
      <div class="mt-2">
        <label class="font-semibold">Razão Social</label>
        <p>{{company.name}}</p>
        <span class="text-danger text-sm" v-show="errors.has('razão social do comprador')">{{ errors.first('razão social do comprador') }}</span>
      </div>

      <div class="mt-2">
        <label class="font-semibold">Data da Fundação</label>
        <p>{{ company.dataInicioAtividade }}</p>
      </div>

      <div class="mt-2">
        <label class="font-semibold">Cnpj / Status</label>
        <p>{{ (company.cnpjAlfa || company.cnpj) | formatCnpj}} / {{ company.cnpjStatus }}</p>
      </div>

      <div class="mt-2">
        <label class="font-semibold">Nome Fantasia</label>
        <p>{{ company.name }}</p>
      </div>

      <div class="mt-2" v-if="tenantType === 'ENERGY'">
        <label class="font-semibold">Tipo Agente</label>
        <vs-select
          v-model="company.companyType"
          autocomplete
          :disabled="readonly"
          name="tipo agente"
          class="w-1/3">
          <vs-select-item :key="index" :value="item.description" :text="item.description" v-for="(item, index) in companyTypes"/>
        </vs-select>
      </div>

      <div class="mt-2">
        <label class="font-semibold">Scorecard</label>
        <p v-if="company.scoreCard">{{ company.scoreCard }}</p>
        <p v-else>Scorecard não cadastrado</p>
      </div>

      <div class="mt-2">
        <label class="font-semibold">Logradouro/número:</label>
        <p>{{ company.descrLogradouro}} {{ company.logradouro }}, {{ company.numero }}</p>
      </div>

      <div class="mt-2">
        <label class="font-semibold">CEP</label>
        <p>{{ company.cep | formatCep }}</p>
      </div>

      <div class="mt-2">
        <label class="font-semibold">Bairro</label>
        <p>{{ company.bairro }}</p>
      </div>

      <div class="mt-2">
        <label class="font-semibold">Telefone</label>
        <p>{{ company.telefone1 }}</p>
      </div>

      <div class="mt-2">
        <label class="font-semibold">Cidade</label>
        <p>{{ company.city }}</p>
      </div>

      <div class="mt-2">
        <label class="font-semibold">Estado</label>
        <p>{{ company.uf }}</p>
      </div>

      <div class="mt-2">
        <label class="font-semibold">E-mail</label>
        <p>{{ company.correioEletronico }}</p>
      </div>

      <div class="mt-2">
        <label class="font-semibold">Matriz</label>
        <p>{{ company.matriz | formatBoolean}}</p>
      </div>

    </div>

    <vs-row v-if="!readonly && tenantType === 'ENERGY'" class="mt-4">
      <vs-col>
        <vs-button @click="validate">Salvar</vs-button>
      </vs-col>
    </vs-row>

  </div>

</template>

<script>
import NumericInput from "@/components/NumericInput";
import axios from "axios";

export default {
  name: 'CompanyForm',
  props: {
    companyForm: Object,
    title: String,
    readonly:{
      default:true,
      type:[String,Boolean]
    },
    tenantType: String,
  },
  components:{
    NumericInput
  },
  watch: {
    companyForm () {
      this.loadCompanyForm()
      // this.getScoreCard()
    }
  },
  data () {
    return {
      scoreCard: null,
      company:{
        name: null,
        cnpj: null,
        sectorName: null,
        companyType: null,
        descrLogradouro: null,
        logradouro: null,
        numero: null,
        complemento: null,
        bairro: null,
        cep: null,
        codIbge: null,
        uf: null,
        telefone1: null,
        dddFax: null,
        correioEletronico: null,
        capitalSocialEmpresa: null,
        dataInicioAtividade: null,
        cnaeCodigo: null,
        codLegalStructure: null,
        matriz: null,
        guid: null,
      },
      companyTypes: [],
    }
  },
  beforeMount() {
    this.loadCompanyType()
  },
  methods: {

    loadCompanyType() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/company-form/types`)
        .then((response) => {
          this.companyTypes = response.data
        })
    },

    loadCompanyForm () {
      Object.assign(this.company, this.companyForm)
    },

    validate () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.updateCompany()
        } else {
          for (const idx in this.errors.items) {
            this.$vs.notify({
              color: 'danger',
              text: this.errors.items[idx].msg
            })
          }
        }
      })
    },

    updateCompany() {
      axios.put(`${process.env.VUE_APP_API  }/api/v1/company-form`, this.company)
        .then((response) => {
          this.company = response.data
        })
        .finally(() => {
          // this.getScoreCard()
        })
    }

  }
}
</script>

<style scoped>

</style>
